export default __webpack_public_path__ + "img/venue_icon-0ded8aad519ca44539e0d9085f0b06ec.png";